module.exports = __webpack_public_path__ + "6add71a9223a79a5e4e2c5b95ba21996.png";